import { FormControlLabel, Checkbox } from "@mui/material";

/**
 * TableOptions
 */

export const TableOptions = ({ label, checked, onChange }: { label: string, checked: boolean | null | undefined, onChange: (checked: boolean) => void }) => {
  return (
    <FormControlLabel
      control={<Checkbox size='small' checked={checked ?? false} onChange={e => onChange(e.target.checked)} />}
      label={label} />
  );
}